export enum FieldType {
  TEXT = 'TEXT',

  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',

  ATTACHED = 'ATTACHED',

  SINGLE_CHOICE = 'SINGLE_CHOICE'
}
